import api from "./api";

export const getMonitoringSummary = async () => {
  const { data } = await api.get("/admin/v1/monitoring/summary");
  return data;
};
